const routes = {
  annualPurchasingPlan: '/plan-anual-compras/:rut',
  buyerCard: '/:rut',
  callback: '/callback',
  claims: '/reclamos/:rut',
  courtLawsuits: '/demandas-judiciales/:rut',
  generalInformation: '/informacion-general/:rut',
  purchaseOrders: '/ordenes-compras/:rut',
  behavior: '/indice-gestion/:rut',
  downloadpdf: '/descargar/:rut'
}

export default routes
